import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const ConfigureWorkflowContent = lazy(() => import('./ConfigureWorkflowContent'));



const ConfigureWorkflow = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <ConfigureWorkflowContent />
        </Suspense>
    );
}

export default ConfigureWorkflow;